var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrazoConcorrencia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.972,
    height: 16.969,
    viewBox: "0 0 16.972 16.969",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prazo-concorrencia",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1698",
    "data-name": "Caminho 1698",
    d: "M16.972,4.109a1.7,1.7,0,0,1-.214.346.607.607,0,0,1-.689.135.627.627,0,0,1-.418-.584,1.368,1.368,0,0,0-.54-1.087,1.224,1.224,0,0,0-.7-.259c-.308-.011-.617,0-.949,0,0,.227.008.452,0,.676a.658.658,0,0,1-1.011.54.64.64,0,0,1-.309-.554c-.005-.215,0-.43,0-.656H9.118v.427c0,.576-.228.883-.658.886s-.667-.307-.667-.894V2.661H4.81c0,.213,0,.431,0,.649a.661.661,0,0,1-1.322.015c-.008-.219,0-.439,0-.691A8.474,8.474,0,0,0,2.351,2.7,1.288,1.288,0,0,0,1.333,3.948c0,.044,0,.088,0,.133q0,5.071,0,10.142A1.3,1.3,0,0,0,2.082,15.5a1.636,1.636,0,0,0,.654.139c.894.015,1.789,0,2.684.008a.637.637,0,0,1,.627.406.608.608,0,0,1-.129.7,1.669,1.669,0,0,1-.346.214H2.358a.2.2,0,0,0-.058-.027A2.687,2.687,0,0,1,0,14.217C.017,10.837,0,7.458.008,4.078a3.151,3.151,0,0,1,.055-.625A2.641,2.641,0,0,1,2.63,1.327c.28-.005.56,0,.856,0,0-.236-.007-.456,0-.675A.661.661,0,0,1,4.809.666c0,.218,0,.436,0,.65H7.793c0-.207,0-.4,0-.6a.664.664,0,1,1,1.325,0c0,.2,0,.394,0,.6h3.016c0-.2,0-.395,0-.587A.665.665,0,1,1,13.459.721c0,.2,0,.394,0,.606.327,0,.636-.014.943,0A2.576,2.576,0,0,1,16.7,2.82a5.565,5.565,0,0,1,.276.858Z",
    transform: "translate(0 0)",
    fill: "#9f0010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1699",
    "data-name": "Caminho 1699",
    d: "M147.227,139.113a2.289,2.289,0,0,1-.4.966,1.944,1.944,0,0,1-1.52.786c-.447.015-.894.008-1.341,0a.661.661,0,1,1,0-1.322c.325-.006.651,0,1.022,0-.124-.142-.22-.264-.328-.375a4.313,4.313,0,1,0-1.082,6.847,1.231,1.231,0,0,1,.369-.137.643.643,0,0,1,.7.452.632.632,0,0,1-.329.783,10.146,10.146,0,0,1-1.27.508,9.243,9.243,0,0,1-1.084.207h-.729c-.411-.075-.83-.121-1.231-.231a5.632,5.632,0,0,1-3.616-7.7,5.556,5.556,0,0,1,2.395-2.639,5.479,5.479,0,0,1,3.248-.707,5.557,5.557,0,0,1,3.8,1.932c.017.019.037.035.082.079,0-.362-.007-.69,0-1.018a.627.627,0,0,1,.4-.594.6.6,0,0,1,.691.118,1.732,1.732,0,0,1,.227.356Z",
    transform: "translate(-130.255 -130.861)",
    fill: "#9f0010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1700",
    "data-name": "Caminho 1700",
    d: "M378.119,265.088a.749.749,0,0,1-.439.52.662.662,0,1,1,.384-.853c.017.045.036.089.054.134Z",
    transform: "translate(-361.147 -253.356)",
    fill: "#9f0010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1701",
    "data-name": "Caminho 1701",
    d: "M233.233,210.076c0,.314,0,.629,0,.943a.711.711,0,0,1-.259.583c-.346.291-.688.587-1.039.872a.66.66,0,0,1-.934-.08.652.652,0,0,1,.075-.921q.324-.295.67-.565a.383.383,0,0,0,.165-.347c-.011-.5-.008-.993,0-1.489a.656.656,0,0,1,.534-.648.649.649,0,0,1,.721.372.885.885,0,0,1,.065.32c.008.32,0,.64,0,.96",
    transform: "translate(-221.265 -199.762)",
    fill: "#9f0010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1702",
    "data-name": "Caminho 1702",
    d: "M357.444,325.222a.658.658,0,1,1,.649-.657.654.654,0,0,1-.649.657",
    transform: "translate(-341.967 -310.462)",
    fill: "#9f0010"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrazoConcorrencia);
export default __webpack_public_path__ + "static/media/prazo-concorrencia.0ef22199b3270bad19b303c0c10735e4.svg";
export { ForwardRef as ReactComponent };